<template>
    <div class="body" v-loading="pageLoading">
        <div class="container-box">
            <div class="card-box padding-box-user left">
                <div class="user-info">
                    <div class="user-info-left">
                        <div>
                            <div class="user-info-profile"><el-icon><UserFilled /></el-icon></div>
                            <div class="user-info-name">{{ pageData.user?.username }}</div>
                        </div>
                        <div class="user-info-left-right">
                            <div>{{ pageData.user?.email }}</div>
                            <div>
                                <div class="user-info-level"><img src="@/assets/20250410-154019.png" alt="">{{ pageData.user?.level_name }}</div>
                                <div>{{ props.lang.Home1 }}：{{ pageData.user?.id }}</div>    
                            </div>
                        </div>
                    </div>
                    <!-- <div class="user-info-right">
                        <div>{{ props.lang.Home2 }}：{{ pageData.user?.last_login_time }}</div>
                        <div>{{ props.lang.Home3 }}：{{ pageData.user?.last_login_ip }}</div>
                    </div> -->
                </div>
                <div class="user-action-box">
                    <div class="user-action-item">
                        <div class="user-action-item-title">{{ props.lang.Home4 }}</div>
                        <div class="user-action-item-content">
                            <div class="user-action-item-content-value">${{ pageData.user?.balance }}</div>
                            <el-button v-if="props.siteInfoObj.open_recharge == 1" type="primary" round size="small" @click="router.push('/balanceRecharge')">{{ props.lang.Home5 }}</el-button>
                            <el-button v-else type="primary" round size="small" @click="router.push('/balanceDetails')">{{ props.lang.Home6 }}</el-button>
                        </div>
                    </div>
                    <div class="user-action-item">
                        <div class="user-action-item-title">{{ props.lang.Home7 }}<el-button link @click="router.push('/userCoupons')">{{ props.lang.Home8 }}</el-button></div>
                        <div class="user-action-item-content">
                            <div class="user-action-item-content-value">{{ pageData.user_coupon }}</div>
                            <el-icon><Ticket /></el-icon>
                        </div>
                    </div>
                    <div class="user-action-item">
                        <div class="user-action-item-title">{{ props.lang.Home9 }}<el-button link @click="router.push('/ticket')">{{ props.lang.Home8 }}</el-button></div>
                        <div class="user-action-item-content">
                            <div class="user-action-item-content-value">{{ pageData.pendingWorkOrder }}</div>
                            <el-icon><List /></el-icon>
                        </div>
                    </div>
                    <div class="user-action-item">
                        <div class="user-action-item-title">{{ props.lang.Home10 }}</div>
                        <div class="user-action-item-content">
                            <a :href="pageData.support" target="_blank" class="user-action-item-btn"><img src="@/assets/20250410-161355.png" alt="">{{ props.lang.Home11 }}</a>
                            <a v-if="props.userInfo.is_partner == 1" target="_blank" class="user-action-item-btn" @click="contactSaler(props.userInfo.sale_telegram,'tg')"><img src="@/assets/20250410-161217.png" alt="">{{ props.lang.Home12 }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-box right">
                <div class="card-box-header">
                    <div class="card-box-header-title">
                        <div></div>
                        <div>{{ props.lang.Home14 }}</div>
                    </div>
                </div>
                <div class="padding-box">
                    <div class="customer-profile">
                        <el-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                <path d="M365.006 485.574c0 39.639 33.033 72.671 72.671 72.671 39.64 0 72.671-33.032 72.671-72.67 0-39.64-33.032-72.672-72.67-72.672-41.29 0-72.672 33.032-72.672 72.671z m325.368-72.67c-39.639 0-72.67 33.031-72.67 72.67s33.031 72.671 72.67 72.671 72.671-33.032 72.671-72.67c0-39.64-33.032-72.672-72.67-72.672z m279.123 14.864h-4.955C914.994 256 759.742 178.374 693.677 146.994c-3.303-1.652-4.954-3.304-8.258-4.955 8.258-8.258 18.168-19.82 21.471-34.684 3.304-16.516-1.651-33.032-13.213-44.594-9.91-11.561-31.38-34.684-158.554-18.167C411.252 57.806 118.916 156.904 61.11 427.768h-6.607c-21.47 0-37.987 16.516-37.987 37.987v120.568c0 21.47 16.516 37.987 37.987 37.987h6.607c42.942 211.406 221.316 303.896 393.084 322.064v1.652c0 21.47 16.516 37.987 37.987 37.987h155.251c21.471 0 37.987-16.516 37.987-37.987v-90.839c0-21.47-16.516-37.987-37.987-37.987H492.181c-21.471 0-37.987 16.516-37.987 37.987v4.955c-99.097-11.561-265.91-61.11-310.504-242.787 11.562-6.607 21.471-19.82 21.471-34.684V464.103c0-14.864-8.258-26.426-19.82-33.032 66.065-257.652 396.388-305.548 399.691-307.2 21.471-3.303 37.987-3.303 52.852-4.955-3.303 8.258-4.955 16.516-4.955 26.426 0 13.213 4.955 33.032 26.426 51.2 8.258 8.258 19.82 13.213 39.639 23.123C716.8 247.742 835.716 307.2 880.31 431.07c-11.562 6.606-19.82 18.168-19.82 33.032v120.568c0 21.47 16.516 37.987 37.987 37.987h72.671c21.471 0 37.987-16.516 37.987-37.987V464.103c-1.651-19.82-18.167-36.335-39.638-36.335z" fill="currentColor"></path>
                            </svg>
                        </el-icon>
                    </div>
                    <div class="customer-name">{{ props.lang.Home14 }}：<img src="@/assets/20250410-161217.png" alt="">{{ props.userInfo.sale_nickname }}</div>
                    <div class="customer-btn-box">
                        <el-popover placement="top" width="auto">
                            <template #reference>
                                <div @click="contactSaler(props.userInfo.sale_qq,'qq')" :class="{'customer-btn': true,'customer-btn-disabled': props.userInfo.sale_qq ? false : true}" style="width: 24%;">
                                    <el-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                            <path d="M538 902l-52 0c-12.667 0-21 2.333-25 7-12.667 12.667-30 22.167-52 28.5s-47.333 9.5-76 9.5c-36.667 0-71-6.333-103-19-4-2-7.833-4.167-11.5-6.5s-6.833-4.5-9.5-6.5-5.167-4.333-7.5-7-4.167-5.167-5.5-7.5-2.333-5-3-8-1-6.167-1-9.5c0-9.333 3.5-17.5 10.5-24.5S221 844.667 237 838c9.333-2.667 15.833-6 19.5-10s5.5-9 5.5-15c0-17.333-2-28-6-32-3.333-4-6.667-9-10-15l-12-16c-3.333-6-6.667-10.667-10-14-6.667-12.667-17.333-19-32-19-4 0-7.5 0.5-10.5 1.5s-6.833 2.833-11.5 5.5-8 4.667-10 6c-12.667 12-21.333 18.333-26 19-7.333 0-11.333-15.333-12-46l0-5c0-21.333 4-57.667 12-109 13.333-38.667 34.667-73 64-103 8.667-8 13-18.667 13-32l0-12c0-19.333 6.333-38.667 19-58 3.333-2.667 5.333-5.5 6-8.5s1-6.5 1-10.5l0-7c0-15.333 1-30.167 3-44.5s5.167-28.167 9.5-41.5 9.833-26.333 16.5-39 14.5-25.167 23.5-37.5 19.167-24.167 30.5-35.5c49.333-55.333 113.333-83 192-83 12.667 0 25 0.667 37 2s23.833 3.5 35.5 6.5 23 6.833 34 11.5 21.667 10 32 16 20.5 13 30.5 21 19.667 16.667 29 26c18 20 33 40 45 60s21.5 41.833 28.5 65.5S794 333.333 794 358l0 7c0 8.667 2 15 6 19 12.667 19.333 19 38.667 19 58l0 12c0 17.333 4.333 28 13 32 30 30 51.333 64.333 64 103 14 43.333 18.333 79.667 13 109 0 15.333-1.5 26.833-4.5 34.5s-7.833 13.167-14.5 16.5c-4.667 0-13.333-6.333-26-19-8.667-8.667-19.333-13-32-13l-12 0c-1.333 0-2.667 0.333-4 1s-2.833 1.167-4.5 1.5-3.167 1.167-4.5 2.5l-4 2-3.5 3.5c0 0-1 1.333-3 4s-2.833 4.167-2.5 4.5c-4.667 12.667-15.333 27.667-32 45-10 10-12.333 20.667-7 32 0 6 5.333 13.333 16 22l3 3c29.333 13.333 44.333 28.333 45 45 0 9.333-3 17.5-9 24.5s-15.667 13.833-29 20.5c-12.667 6-28 10.667-46 14s-37 5-57 5c-53.333 0-96-12.667-128-38 4.667 0 3.667-1.333-3-4L538 902zM685 1024c64 0 115-12.667 153-38 20.667-14 36.5-29.333 47.5-46s16.5-35.667 16.5-57c0-23.333-6.333-44.667-19-64l9 0c2 0 4.833-0.5 8.5-1.5s6.5-2.5 8.5-4.5c36-12 57.333-44 64-96 6-44.667-0.333-96-19-154-2.667-8.667-5.833-17.333-9.5-26s-7.667-17-12-25-9.167-16-14.5-24-10.833-15.667-16.5-23-11.833-15-18.5-23c0-28-6.333-58-19-90 0-32-3.667-62.5-11-91.5s-18.5-56.833-33.5-83.5-34.167-51.667-57.5-75c-10-10-20.333-19.167-31-27.5s-21.5-16-32.5-23-22.333-13.333-34-19S640.833 22 628.5 18 603.667 10.667 591 8s-25.5-4.667-38.5-6S526 0 512 0c-32 0-62.5 3.667-91.5 11S363.667 29.5 337 44.5s-51.667 34.167-75 57.5c-68 76-102 159.333-102 250-12.667 25.333-19 55.333-19 90l0 6c-9.333 7.333-17.833 15.833-25.5 25.5s-14.333 19.667-20 30-10.333 20.167-14 29.5S74 552.333 70 563c-18.667 58-25 109.333-19 154 3.333 24.667 10.667 45.167 22 61.5s25.333 27.833 42 34.5c2 0 6.333 1 13 3s11 3 13 3c-12.667 19.333-19 40.667-19 64 0 44 21.333 78.333 64 103 9.333 6 19.5 11.5 30.5 16.5s22.833 9 35.5 12 25.667 5.333 39 7c13.333 1.667 27.333 2.5 42 2.5 70.667 0 124-15 160-45l32 0C567 1009 620.333 1024 685 1024z" fill="currentColor"></path>
                                        </svg>
                                    </el-icon>
                                </div>
                            </template>
                            <div v-if="props.userInfo.sale_qq" class="customer-btn-copy" @click="tools.copyText(props.userInfo.sale_qq)">
                                qq：{{ props.userInfo.sale_qq }}
                            </div>
                            <div v-else>{{ props.lang.Home32 }}</div>
                        </el-popover>
                        <el-popover placement="top" width="auto">
                            <template #reference>
                                <div @click="contactSaler(props.userInfo.sale_telegram,'tg')" :class="{'customer-btn': true,'customer-btn-disabled': props.userInfo.sale_telegram ? false : true}" style="width: 24%;">
                                    <el-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                            <path d="M24.649143 399.36L965.485714 7.314286a29.257143 29.257143 0 0 1 39.643429 34.084571l-234.349714 937.472a29.257143 29.257143 0 0 1-47.104 15.36l-203.483429-169.545143a29.257143 29.257143 0 0 0-39.424 1.828572l-104.374857 104.301714a29.257143 29.257143 0 0 1-49.883429-20.626286V689.737143a29.257143 29.257143 0 0 1 8.557715-20.699429l424.448-424.448-501.101715 375.881143a29.257143 29.257143 0 0 1-36.278857-0.950857L17.188571 448.804571a29.257143 29.257143 0 0 1 7.460572-49.444571z" fill="currentColor"></path>
                                        </svg>
                                    </el-icon>
                                </div>
                            </template>
                            <div v-if="props.userInfo.sale_telegram" class="customer-btn-copy" @click="tools.copyText('@'+props.userInfo.sale_telegram)">
                                telegram：@{{ props.userInfo.sale_telegram }}
                            </div>
                            <div v-else>{{ props.lang.Home32 }}</div>
                        </el-popover>
                        <el-popover placement="top" width="auto">
                            <template #reference>
                                <div :class="{'customer-btn': true,'customer-btn-disabled': props.userInfo.sale_skype ? false : true}" style="width: 24%;">
                                    <el-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                            <path d="M975.750381 598.919427a487.905308 487.905308 0 0 0 8.07152-86.919427c0-288.406249-257.144168-518.504802-558.802166-463.750984A267.986508 267.986508 0 0 0 271.058505 0.000602 271.359681 271.359681 0 0 0 0 271.059107c0 55.476641 16.624922 108.423402 48.248414 154.021466-5.360935 29.515259-8.07152 58.669107-8.07152 86.919427 0 288.406249 257.204403 518.504802 558.802166 463.750984A267.986508 267.986508 0 0 0 752.940291 1023.999398c149.443589 0 271.058505-121.614916 271.058504-271.058505 0-55.476641-16.624922-108.423402-48.248414-154.021466zM752.940291 963.764174a209.19693 209.19693 0 0 1-128.481732-43.911477l-10.96281-8.432932-13.552925 2.831056a412.008927 412.008927 0 0 1-490.194247-490.254482l2.77082-13.552925-8.432931-10.962811A209.257166 209.257166 0 0 1 60.235223 271.059107C60.235223 154.805126 154.804524 60.235826 271.058505 60.235826c46.682298 0 91.075658 15.179276 128.481731 43.911477l10.96281 8.432932 13.552926-2.831056a412.008927 412.008927 0 0 1 490.134011 490.254482l-2.77082 13.552925 8.432931 10.962811c28.732201 37.285603 43.911478 81.799433 43.911478 128.421496 0 116.253981-94.569301 210.823281-210.823281 210.823281z m13.191514-347.015121c0 127.397497-123.000326 186.367781-240.940893 186.367781-141.191363 0-259.192166-62.765103-259.192166-139.926424 0-34.454548 19.455977-65.837099 63.42769-65.837099 67.162274 0 73.426737 96.617298 189.500012 96.617298 55.175464 0 90.955187-24.395265 90.955187-56.440404 0-40.176894-34.514783-46.441357-90.352834-60.235223l-91.617775-22.588209c-91.557539-21.985856-161.91228-59.632871-161.91228-165.044511 0-127.337262 126.132557-174.441207 234.67643-174.441207 118.603155 0 238.411014 47.043709 238.411013 119.205507 0 36.382075-24.455501 68.427214-65.234746 68.427213-60.897811 0-62.765103-72.101562-161.309928-72.101562-55.175464 0-90.352835 14.998571-90.352835 48.248414 0 36.44231 35.779723 44.574065 83.546254 55.898287l65.174512 15.058806c89.14813 20.058329 195.222359 57.645109 195.222359 166.791333z" fill="currentColor"></path>
                                        </svg>
                                    </el-icon>
                                </div>
                            </template>
                            <div v-if="props.userInfo.sale_skype" class="customer-btn-copy" @click="tools.copyText(props.userInfo.sale_skype)">
                                skype：{{ props.userInfo.sale_skype }}
                            </div>
                            <div v-else>{{ props.lang.Home32 }}</div>
                        </el-popover>
                        <el-popover placement="top" width="auto">
                            <template #reference>
                                <div :class="{'customer-btn': true,'customer-btn-disabled': props.userInfo.sale_whatsapp ? false : true}" style="width: 24%;">
                                    <el-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                                            <path d="M872.992 148.8C777.184 52.8 649.792 0 513.984 0 234.368 0 6.784 227.584 6.784 507.392c0 89.408 23.392 176.8 67.808 253.6L2.592 1024l268.992-70.592a507.456 507.456 0 0 0 242.4 61.792h0.192c279.616 0 507.392-227.616 507.392-507.392 0-135.616-52.8-263.008-148.608-359.008z m-358.784 780.8a421.44 421.44 0 0 1-214.816-58.784l-15.392-9.216-159.584 41.792 42.592-155.616-10.016-16a418.752 418.752 0 0 1-64.608-224.384c0-232.608 189.184-421.792 422.016-421.792 112.608 0 218.592 44 298.208 123.584a419.456 419.456 0 0 1 123.392 298.4c-0.192 232.8-189.408 422.016-421.792 422.016z m231.2-316c-12.608-6.4-75.008-36.992-86.592-41.216s-20-6.4-28.608 6.4c-8.384 12.608-32.8 41.216-40.192 49.792-7.392 8.384-14.784 9.6-27.392 3.2s-53.6-19.808-102.016-63.008c-37.6-33.6-63.2-75.2-70.592-87.808s-0.8-19.616 5.6-25.792c5.792-5.6 12.608-14.816 19.008-22.208s8.384-12.608 12.608-21.184c4.192-8.384 2.208-15.808-0.992-22.208s-28.608-68.8-39.008-94.208c-10.208-24.8-20.8-21.408-28.608-21.792-7.392-0.384-15.808-0.384-24.192-0.384s-22.208 3.2-33.792 15.808c-11.616 12.608-44.384 43.392-44.384 105.792s45.408 122.592 51.808 131.2c6.4 8.384 89.408 136.608 216.608 191.392 30.208 12.992 53.792 20.8 72.192 26.784 30.4 9.6 58.016 8.192 79.808 4.992 24.384-3.616 75.008-30.592 85.6-60.192s10.592-55.008 7.392-60.192c-3.008-5.6-11.392-8.8-24.192-15.2z" fill="currentColor"></path>
                                        </svg>
                                    </el-icon>
                                </div>
                            </template>
                            <div v-if="props.userInfo.sale_whatsapp" class="customer-btn-copy" @click="tools.copyText(props.userInfo.sale_whatsapp)">
                                whatsapp：{{ props.userInfo.sale_whatsapp }}
                            </div>
                            <div v-else>{{ props.lang.Home32 }}</div>
                        </el-popover>
                    </div>
                    <div class="customer-btn customer-btn-color1" @click="router.push('/ticketAdd')">{{ props.lang.Home16 }}</div>
                </div>
            </div>
        </div>
        <div class="container-box">
            <div class="card-box left">
                <div class="card-box-header">
                    <div class="card-box-header-title">
                        <div></div>
                        <div>{{ props.lang.Home17 }}</div>
                    </div>
                </div>
                <div class="data-box padding-box">
                    <div class="data-item">
                        <div class="data-item-value" style="color: #fca74f">{{ pageData.serverTotal }}</div>
                        <div class="data-item-title">{{ props.lang.Home18 }}</div>
                    </div>
                    <div class="data-item-line"></div>
                    <div class="data-item">
                        <div class="data-item-value" style="color: #78c7bf">{{ pageData.domainrTotal }}</div>
                        <div class="data-item-title">{{ props.lang.Home19 }}</div>
                    </div>
                    <div class="data-item-line"></div>
                    <div class="data-item">
                        <div class="data-item-value" style="color: #4a07e5">{{ pageData.expirWeekServers }}</div>
                        <div class="data-item-title">{{ props.lang.Home20 }}</div>
                    </div>
                    <div class="data-item-line"></div>
                    <div class="data-item">
                        <div class="data-item-value" style="color: #cb0ced">{{ pageData.expirWeekVps }}</div>
                        <div class="data-item-title">{{ props.lang.Home21 }}</div>
                    </div>
                    <div class="data-item-line"></div>
                    <div class="data-item">
                        <div class="data-item-value" style="color: #1a73d4">{{ pageData.expirWeekCloud }}</div>
                        <div class="data-item-title">{{ props.lang.Home22 }}</div>
                    </div>
                </div>
            </div>
            <div class="card-box right">
                <div class="card-box-header">
                    <div class="card-box-header-title">
                        <div></div>
                        <div>{{ props.lang.Home23 }}</div>
                    </div>
                    <el-button type="warning" link @click="toNews(false)">more</el-button>
                </div>
                <div class="padding-box">
                    <div v-for="item in pageData.news_list" :key="item.id" class="news-item" @click="toNews(item.id)">
                        <el-tag>{{ props.lang.Home24 }}</el-tag>
                        <div class="news-item-title">{{ item.title }}</div>
                        <div class="news-item-time">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-box">
            <div class="card-box left">
                <div class="card-box-header">
                    <div class="card-box-header-title">
                        <div></div>
                        <div>{{ props.lang.Home25 }}</div>
                    </div>
                </div>
                <div class="product-box padding-box">
                    <div class="product-item" @click="router.push('/domainList')">
                        <el-icon><Location /></el-icon>
                        <div>{{ props.lang.Home26 }}</div>
                    </div>
                    <div class="product-item" @click="router.push('/serverList')">
                        <el-icon><Refrigerator /></el-icon>
                        <div>{{ props.lang.Home27 }}</div>
                    </div>
                    <div class="product-item" @click="router.push('/sslList')">
                        <el-icon><Lock /></el-icon>
                        <div>{{ props.lang.Home28 }}</div>
                    </div>
                    <div class="product-item" @click="router.push('/cloudList')">
                        <el-icon><MostlyCloudy /></el-icon>
                        <div>{{ props.lang.Home29 }}</div>
                    </div>
                    <div class="product-item" @click="router.push('/vpsList')">
                        <el-icon><Cloudy /></el-icon>
                        <div>VPS</div>
                    </div>
                    <div class="product-item-placeholder"></div>
                </div>
            </div>
            <div class="card-box right">
                <div class="card-box-header">
                    <div class="card-box-header-title">
                        <div></div>
                        <div>{{ props.lang.Home30 }}</div>
                    </div>
                    <el-button type="warning" link @click="toArticle(false)">more</el-button>
                </div>
                <div class="padding-box">
                    <div v-for="item in pageData.article_list" :key="item.id" class="news-item" @click="toArticle(item.id)">
                        <el-tag type="success">{{ props.lang.Home31 }}</el-tag>
                        <div class="news-item-title">{{ item.title }}</div>
                        <div class="news-item-time">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount,ref } from 'vue'
import { useRouter } from 'vue-router'
import { userStatistics } from '@/api/api.js'
import { webUrl } from '@/api/api.js'
import tools from '@/common/tools.js'
let router = useRouter()

let props = defineProps({
    siteInfoObj: Object,
    lang: Object,
    userInfo: Object,
    setMenuActive: Function,
})

let pageLoading = ref(false)
let pageData = ref({})
let resourceTableData = ref([])

// 获取数据
let getData = () => {
    pageLoading.value = true
    userStatistics().then(res => {
        if(res.data.status == 200) {
            pageData.value = res.data.data
        } else {
            ElMessage.error(res.data.message)
        }
        pageLoading.value = false
    })
}
// 跳转公告通知页面
let toNews = id => {
    if(id) {
        location.href = webUrl + '/news/' + id + '.html'
    } else {
        location.href = webUrl + '/news.html'
    }
}
// 跳转帮助公告页面
let toArticle = id => {
    if(id) {
        location.href = webUrl + '/article/' + id + '.html'
    } else {
        location.href = webUrl + '/article.html'
    }
}
// 联系客服
let contactSaler = (url,type) => {
    if(url) {
        if(type == 'qq') {
            window.open(`https://wpa.qq.com/msgrd?v=3&uin=${url}&site=qq&menu=yes`)
        } else if(type == 'tg') {
            window.open(`https://t.me/${url}`)
        }
    }
}

onBeforeMount(() => {
    props.setMenuActive('/')
    getData()
})

</script>


<style scoped>
    a{
        text-decoration: unset;
    }
    .card-box{
        padding: 0;
    }
    .container-box{
        display: flex;
        justify-content: space-between;
        height: fit-content;
        margin-bottom: 20px;
    }
    .padding-box-user{
        padding: 25px;
    }
    .padding-box{
        padding: 16px;
    }
    .container-box .left{
        width: 72%;
    }
    .container-box .right{
        width: 26%;
    }
    .user-info{
        display: flex;
        justify-content: space-between;
        margin-bottom: 26px;
    }
    .user-info-left{
        display: flex;
        align-items: center;
    }
    .user-info-profile{
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 86px;
        border-radius: 50%;
        background: #ff8f17;
        margin: 0 auto 8px auto;
    }
    .user-info-profile .el-icon{
        font-size: 42px;
        color: white;
    }
    .user-info-name{
        color: #fca74f;
        font-size: 16px;
        font-weight: bold;
    }
    .user-info-left-right{
        margin-left: 20px;
        font-size: 16px;
        color: #2e2e2e;
    }
    .user-info-left-right>div:first-child{
        margin-bottom: 10px;
    }
    .user-info-left-right>div:last-child{
        display: flex;
        align-items: center;
    }
    .user-info-level{
        background: #2e4154;
        border-radius: 50px;
        border: 3px solid #8fa4b9;
        color: white;
        display: flex;
        align-items: center;
        font-size: 14px;
        padding: 0 8px;
        margin-right: 4px;
    }
    .user-info-level img{
        width: 22px;
        margin-right: 2px;
    }
    .user-info-right{
        color: #999;
        font-size: 12px;
    }
    .user-info-right>div:first-child{
        margin-bottom: 2px;
    }
    .user-action-box{
        display: flex;
        justify-content: space-between;
        height: fit-content;
    }
    .user-action-item{
        background: #f7f7f7;
        padding: 12px 16px;
        width: 23%;
        height: initial;
        border-radius: 12px;
    }
    .user-action-item-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        font-size: 14px;
        color: #333;
    }
    .user-action-item-content{
        display: flex;
        justify-content: space-between;
    }
    .user-action-item-content-value{
        color: #fca74f;
        font-size: 18px;
        font-weight: bold;
    }
    .user-action-item-content .el-icon{
        font-size: 62px;
        color: #ff8f17;
    }
    .user-action-item-btn{
        background: white;
        padding: 4px 10px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        border: 1px solid #fff;
        margin-top: 26px;
    }
    .user-action-item-btn:hover{
        border: 1px solid #ff8f17;
    }
    .user-action-item-btn img{
        width: 20px;
        margin-right: 6px;
    }
    .card-box-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        border-bottom: 1px solid #f0f0f0;
    }
    .card-box-header-title{
        font-size: 16px;
        color: #333;
        font-weight: bold;
        display: flex;
        align-items: center;
    }
    .card-box-header-title div:first-child{
        background: #ff8f17;
        width: 4px;
        height: 24px;
        border-radius: 50px;
        margin-right: 8px;
    }
    .customer-profile{
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 86px;
        border-radius: 50%;
        background: #ff8f17;
        margin: 8px auto 20px auto;
    }
    .customer-profile .el-icon{
        font-size: 42px;
        color: white;
    }
    .customer-name{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #333;
        margin-bottom: 16px;
    }
    .customer-name img{
        width: 20px;
        margin-right: 6px;
    }
    .customer-btn-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }
    .customer-btn{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 0;
        cursor: pointer;
        font-size: 14px;
        background: #fee9d1;
        color: #fca74f;
        border: 2px solid #fee9d1;
    }
    .customer-btn .el-icon{
        font-weight: bold;
        font-size: 18px;
        color: #fca74f;
        margin-right: 4px;
    }
    .customer-btn-disabled{
        opacity: .5;
        cursor: no-drop;
    }
    .data-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .data-item{
        height: 140px;
        width: 140px;
        border-radius: 50%;
        background: radial-gradient(closest-side, rgb(226, 226, 226), #fff);
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .data-item-value{
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .data-item-title{
        text-align: center;
        font-size: 15px;
        color: #5c707c;
        font-weight: bold;
    }
    .data-item-line{
        background: #ebebeb;
        width: 3px;
        height: 48px;
        border-radius: 50px;
    }
    .news-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 8px;
    }
    .news-item:last-child{
        margin-bottom: 0;
    }
    .news-item-title{
        flex: 1;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #555;
        margin: 0 8px;
    }
    .news-item-time{
        font-size: 12px;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .product-box{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .product-item{
        width: 32%;
        background: #f5f5f5;
        height: 82px;
        cursor: pointer;
        margin-bottom: 20px;
        display: flex;
        font-size: 15px;
        color: #5c707c;
        padding: 14px;
        font-weight: bold;
    }
    .product-item:hover{
        background: #fee9d1;
    }
    .product-item .el-icon{
        color: #ff8f17;
        font-size: 20px;
        font-weight: bold;
        margin-right: 8px;
    }
    .product-item-placeholder{
        width: 32%;
        height: 1px;
    }
    .customer-btn-copy{
        cursor: pointer;
    }
    .customer-btn-copy:hover{
        color: #409eff;
    }
    /* 手机样式 */
    @media (max-width: 1024px) {
        .padding-box-user{
            padding-left: 4%;
            padding-right: 4%;
        }
        .container-box{
            flex-wrap: wrap;
        }
        .container-box .left{
            width: 100%;
            margin-bottom: 20px;
        }
        .container-box .right{
            width: 100%;
        }
        .user-info{
            flex-wrap: wrap;
        }
        .user-info-left{
            width: 100%;
            margin-bottom: 18px;
        }
        .user-info-right{
            width: 100%;
        }
        .user-action-box{
            flex-wrap: wrap;
        }
        .user-action-item{
            width: 100%;
            margin-bottom: 12px;
        }
        .user-action-item:last-child{
            margin-bottom: 0;
        }
        .data-box{
            flex-wrap: wrap;
        }
        .data-item{
            margin-bottom: 8px;
        }
        .data-item-line{
            display: none;
        }
        .product-item{
            width: 48%;
        }
    }
</style>